import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useRef, useState } from 'react';
import { arrayOf, number, shape, string } from 'prop-types';
import { routePush } from '@magalu/mixer-utils';
import withLayoutProps from '../../../hocs/withLayoutProps';
import SeoCategoryTreeLinksDesktop from './SeoCategoryTreeLinksDesktop';
import SeoCategoryTreeLinksMobile from './SeoCategoryTreeLinksMobile';
import { Card, CollapsibleContent, SeeMoreButton, Title } from './SeoCategoryTreeLinks.styles';
var SeoCategoryTreeLinks = function SeoCategoryTreeLinks(_ref) {
  var staticProps = _ref["static"],
    structure = _ref.structure;
  var _staticProps$collapse = staticProps.collapsedHeight,
    collapsedHeight = _staticProps$collapse === void 0 ? 320 : _staticProps$collapse,
    columns = staticProps.columns,
    linkGroups = staticProps.linkGroups;
  var groups = linkGroups == null ? void 0 : linkGroups.subtree;
  var label = linkGroups == null ? void 0 : linkGroups.label;
  var contentRef = useRef(null);
  var innerRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    contentHeight = _useState4[0],
    setContentHeight = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isOverflowing = _useState6[0],
    setIsOverflowing = _useState6[1];
  useEffect(function () {
    if (!contentRef.current) return undefined;
    var measure = function measure() {
      var scrollHeight = contentRef.current.scrollHeight;
      setContentHeight(scrollHeight);
      setIsOverflowing(scrollHeight > collapsedHeight);
    };
    measure();
    if (typeof ResizeObserver === 'undefined' || !innerRef.current) {
      return undefined;
    }
    var observer = new ResizeObserver(measure);
    observer.observe(innerRef.current);
    return function () {
      return observer.disconnect();
    };
  }, [groups, collapsedHeight]);
  if (!groups || groups.length === 0) return null;
  var onLinkClick = function onLinkClick(e, href) {
    e.preventDefault();
    routePush({
      path: href,
      spa: true
    });
  };
  var isMobile = (structure == null ? void 0 : structure.device) === 'mobile';
  return React.createElement(Card, {
    isMobile: isMobile
  }, label && React.createElement(Title, null, label), React.createElement(CollapsibleContent, {
    ref: contentRef,
    collapsedHeight: collapsedHeight,
    contentHeight: contentHeight,
    isExpanded: isExpanded,
    isOverflowing: isOverflowing
  }, React.createElement("div", {
    ref: innerRef
  }, isMobile ? React.createElement(SeoCategoryTreeLinksMobile, {
    groups: groups,
    onLinkClick: onLinkClick
  }) : React.createElement(SeoCategoryTreeLinksDesktop, {
    columns: columns,
    groups: groups,
    onLinkClick: onLinkClick
  }))), isOverflowing && React.createElement(SeeMoreButton, {
    type: "button",
    "aria-expanded": isExpanded,
    "data-testid": "seo-category-tree-links-toggle",
    onClick: function onClick() {
      return setIsExpanded(function (prev) {
        return !prev;
      });
    }
  }, isExpanded ? 'Ver menos' : 'Ver mais'));
};
SeoCategoryTreeLinks.ssr = true;
process.env.NODE_ENV !== "production" ? SeoCategoryTreeLinks.propTypes = {
  "static": shape({
    collapsedHeight: number,
    columns: number,
    linkGroups: shape({
      href: string,
      label: string,
      subtree: arrayOf(shape({
        href: string,
        label: string,
        subtree: arrayOf(shape({
          href: string,
          label: string
        }))
      }))
    })
  }),
  structure: shape({
    device: string
  })
} : void 0;
SeoCategoryTreeLinks.defaultProps = {
  "static": {
    collapsedHeight: 320,
    columns: 4,
    linkGroups: {}
  },
  structure: {}
};
export default withLayoutProps(SeoCategoryTreeLinks);